import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { CustomizesearchbarComponent } from './pages/customizesearchbar/customizesearchbar.component';
import { CustomizeuroComponent } from './pages/customizeuro/customizeuro.component';
import { CustomizemonthComponent } from './pages/customizemonth/customizemonth.component';
import { CustomizedurationComponent } from './pages/customizeduration/customizeduration.component';
import { CustomizeinterestsComponent } from './pages/customizeinterests/customizeinterests.component';
import { CustomizeviewComponent } from './pages/customizeview/customizeview.component';
import { VedioComponent } from './pages/vedio/vedio.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UploadImagesComponent } from './pages/upload-images/upload-images.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CustomizesearchbarComponent,
    CustomizeuroComponent,
    CustomizemonthComponent,
    CustomizedurationComponent,
    CustomizeinterestsComponent,
    CustomizeviewComponent,
    VedioComponent,
    UploadImagesComponent
  ],
  imports: [
    BrowserModule,FormsModule, ReactiveFormsModule ,
    AppRoutingModule,

  ],
  providers: [
  
  
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
